const getStructureId = (planSer, fraction, groupIndex) =>
  `structure-${planSer}-${fraction}-${groupIndex}`;

export default getStructureId;